"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const luxon_1 = require("luxon");
const react_redux_1 = require("react-redux");
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const transactions_1 = require("companion-app-components/flux/transactions");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const AlarmOn_1 = __importDefault(require("@mui/icons-material/AlarmOn"));
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const selectors_1 = require("data/transactions/selectors");
const core_1 = require("components/QCurrency/core");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QMenu_1 = __importDefault(require("components/QMenu"));
const useQData_1 = __importDefault(require("components/QData/useQData"));
const utils_1 = require("data/transactions/utils");
const constants_1 = require("utils/constants");
const schTxnsIsNextMenuOption = [
    { label: 'Enter this reminder', value: 'ACCEPT' },
    { label: 'Ignore this reminder', value: 'SKIP' },
    { label: 'Go to Bills', value: 'BILLS' },
];
const schTxnsMenuOption = [
    { label: 'Enter this and all previous overdue reminders for this Payee as Paid', value: 'ACCEPT' },
    { label: 'Ignore this and all previous overdue reminders for this Payee', value: 'SKIP' },
    { label: 'Go to Bills', value: 'BILLS' },
];
const schTxnsGrossPaycheckMenuOption = [
    { label: 'Go to Bills', value: 'BILLS' },
];
const TableTxnRow = (props) => {
    var _a, _b, _c, _d;
    const { columns, classes, txn, onGoToRegister, onGoToBills } = props;
    const incomeCOAIds = (0, react_redux_1.useSelector)(categories_1.categoriesSelectors.getIncomeCOAIds);
    const accountsById = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    const allAccountsById = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAllAccounts);
    const transactionsByAccountId = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getTransactionsByAccountId)(state, undefined));
    const accountTransactions = transactionsByAccountId === null || transactionsByAccountId === void 0 ? void 0 : transactionsByAccountId.get((_a = txn.accountId) !== null && _a !== void 0 ? _a : '');
    const scheduledTransactions = (0, react_redux_1.useSelector)(scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactions);
    const category = (0, react_redux_1.useSelector)((state) => txn.coa && chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(state, txn.coa, true));
    const isTransferTxnAccountAvailable = (0, react_redux_1.useSelector)((state) => (0, selectors_1.isTransferAccountAvailable)(state, txn));
    const { qDataPerformTransactionAction } = (0, useQData_1.default)('calendarTxnModal_TxPage');
    const isTxnInCurrentAccountGroup = (0, react_1.useMemo)(() => accountsById && accountsById.some(({ id }) => id === txn.accountId), [accountsById, txn.accountId]);
    const defaultMenuOption = isTxnInCurrentAccountGroup ? [{ label: 'Go to Register', value: 'REGISTER' }] : [];
    const type = (0, react_1.useMemo)(() => (0, utils_1.getCalendarTxnType)(txn, incomeCOAIds), [txn, incomeCOAIds]);
    const recurringStatus = (0, react_1.useMemo)(() => (0, utils_1.getTxnStateInfo)(txn), [txn]);
    const isUnacceptedSchTxn = (0, react_1.useMemo)(() => (0, utils_1.isUnacceptedScheduledTxn)(txn), [txn]);
    const nextInstance = (0, react_1.useMemo)(() => {
        var _a;
        return accountTransactions && txn.stModelId &&
            (0, utils_1.nextScheduledInstanceAfterDate)((_a = luxon_1.DateTime.now().toISODate()) !== null && _a !== void 0 ? _a : '', accountTransactions, txn.stModelId);
    }, [accountTransactions, txn]);
    const isNext = (0, react_1.useMemo)(() => nextInstance && nextInstance.id === txn.id, [nextInstance, txn]);
    const isUpcoming = (0, utils_1.isNextScheduledInstance)(txn, scheduledTransactions);
    let menuOptions = null;
    let reminderIconClass = null;
    let qtipTitle = null;
    const scheduledTransactionsById = (0, react_redux_1.useSelector)(scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactions);
    const stRecord = scheduledTransactionsById.find((item) => item.id === txn.stModelId);
    const isTypeGrossPaycheck = Boolean((stRecord === null || stRecord === void 0 ? void 0 : stRecord.type) === 'GROSS_PAYCHECK');
    if (isTypeGrossPaycheck) {
        menuOptions = schTxnsGrossPaycheckMenuOption;
    }
    else if (isUnacceptedSchTxn) {
        // if this scheduled instance contains transfers to unsynced accounts, then do not allow the user to act
        // @ts-expect-error: An argument for 'state' was not provided.
        menuOptions = !(0, utils_1.transactionEditsNotAllowed)(txn) && isUpcoming ? schTxnsIsNextMenuOption : schTxnsMenuOption;
    }
    const { income, expense, overdue, normal } = transactions_1.transactionsTypes.calTxnLabelTypes;
    switch (type) {
        case income:
        case expense:
            if (recurringStatus.status === 'DUE') {
                qtipTitle = 'This reminder is due';
                reminderIconClass = classes.dueType;
            }
            else {
                if (isNext) {
                    qtipTitle = 'This will be the next instance that becomes due';
                }
                else {
                    qtipTitle = 'This reminder is not yet due';
                    menuOptions = null;
                }
                reminderIconClass = classes.notDue;
            }
            break;
        case overdue:
            qtipTitle = 'This reminder is overdue';
            reminderIconClass = classes.overdueType;
            break;
        case normal:
        default:
            reminderIconClass = null;
    }
    if (reminderIconClass && category === '[Unsynced Account]') {
        menuOptions = schTxnsGrossPaycheckMenuOption;
    }
    const onMenuChange = (0, react_1.useCallback)((action) => {
        if (action === 'BILLS') {
            // @ts-expect-error: stModelId may be null but onGoToBills expects string
            onGoToBills(txn.stModelId);
            return;
        }
        if (action === 'REGISTER') {
            onGoToRegister(txn);
            return;
        }
        const actionObj = {
            id: txn.id,
            action,
            overdueAction: action,
            instanceDate: txn.stDueOn,
        };
        qDataPerformTransactionAction(actionObj);
    }, [onGoToBills, onGoToRegister, txn, qDataPerformTransactionAction]);
    let categoryName = category;
    let showOptionsCell = Boolean(defaultMenuOption === null || defaultMenuOption === void 0 ? void 0 : defaultMenuOption.length);
    if (transactions_1.transactionsUtils.isTransferTxn(txn)) {
        if (!isTransferTxnAccountAvailable) {
            categoryName = '[Transfer]';
        }
        if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
            const splitItems = (_c = (_b = txn === null || txn === void 0 ? void 0 : txn.split) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [];
            const coaIds = splitItems
                .map((split) => split === null || split === void 0 ? void 0 : split.coa)
                .filter((coa) => !!coa && coa.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.ACCOUNT)
                .map((coa) => coa.id);
            const isTransferAccountPresent = coaIds.some((id) => Boolean(accountsById.get(id)));
            if (!isTransferAccountPresent) {
                showOptionsCell = false;
            }
        }
        else {
            const isTransferAccountPresent = accountsById.get((_d = txn.coa) === null || _d === void 0 ? void 0 : _d.id);
            if (!isTransferAccountPresent) {
                showOptionsCell = false;
            }
        }
    }
    return (<TableRow_1.default className={classes.tableBodyRow}>
      {Object.keys(columns).map((key) => {
            var _a, _b;
            let cell = null;
            switch (key) {
                case 'reminderCol':
                    cell = (<div className={classes.reminderColContainer}>
                {reminderIconClass && (<QTip_1.default title={qtipTitle} wrapId={`qtip-${txn.id}-recurring`}>
                    <AlarmOn_1.default className={(0, classnames_1.default)(classes.reminderIcon, reminderIconClass)}/>
                  </QTip_1.default>)}
              </div>);
                    break;
                case 'payeeCol':
                    cell = <div className={classes.payeeColContainer}>{txn.payee || constants_1.APP_STRING_NO_PAYEE}</div>;
                    break;
                case 'accountCol':
                    cell = <div className={classes.accountColContainer}>{(_b = allAccountsById === null || allAccountsById === void 0 ? void 0 : allAccountsById.get((_a = txn.accountId) !== null && _a !== void 0 ? _a : '')) === null || _b === void 0 ? void 0 : _b.name}</div>;
                    break;
                case 'categoryCol':
                    cell = (<div className={classes.categoryColContainer}>
                {txn.split ? constants_1.APP_STRING_SPLIT : categoryName}
              </div>);
                    break;
                case 'amountCol':
                    cell = <div className={classes.amountColContainer}>{(0, core_1.formatAmount)(txn.amount)}</div>;
                    break;
                case 'optionsCol':
                    {
                        const customTrigger = (<ExpandMore_1.default className={classes.expandIcon}/>);
                        cell = showOptionsCell ? (<div className={classes.optionsColContainer}>
                <QMenu_1.default customTrigger={customTrigger} name={`qmenu-${txn.id}-recurring`} title={qtipTitle} menuIconButtonSize="small" options={menuOptions || defaultMenuOption} onChange={onMenuChange} customTriggerClass={classes.expandIconRoot} anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }} transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}/>
              </div>) : null;
                    }
                    break;
                default: break;
            }
            return (<TableCell_1.default key={`cell-${txn.id}-${key}`} className={(0, classnames_1.default)(classes.tableBodyCell, classes === null || classes === void 0 ? void 0 : classes[key])}>
            {cell}
          </TableCell_1.default>);
        })}
    </TableRow_1.default>);
};
exports.default = react_1.default.memo(TableTxnRow);
